import fetch from '@/utils/fetch';

//  首页
export function getMain(data = {}) {
  return fetch({
    url: `/saas/cms/w/xcx/shop/main`,
    method: 'post',
    data,
  });
}

//  首页
export function getShopinfos(data = {}) {
  return fetch({
    url: `/saas/user/m/shop/self`,
    method: 'post',
    data,
  });
}


export function getMenu(data = {}) {
  return fetch({
    url: '/saas/user/m/shop/manager/menu',
    method: 'post',
    data,
  });
}

//直播列表
export function getLivelist(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/list`,
    method: 'post',
    data,
  });
}

//修改直播状态
export function liveStatusChange(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/interface`,
    method: 'post',
    data,
  });
}

// 直播删除
export function liveDelete(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/delete`,
    method: 'post',
    data,
  });
}

/**
 * 获取商品列表
 */
export function goodsList(data = {}) {
  return fetch({
    url: '/saas/cms/m/s/good/list',
    method: 'post',
    data,
  });
}

// 直播关联后列表
export function livegoodsList(data = {}) {
  return fetch({
    url: `saas/live/m/s/live/good/list`,
    method: 'post',
    data,
  });
}

/**
 * 直播关联拍品列表
 */
export function aucArtworkList(data = {}) {
  return fetch({
    url: '/saas/cms/m/s/auction/artwork/list',
    method: 'post',
    data,
  });
}
// 删除商品
export function deleteGood(data = {}) {
  return fetch({
    url: '/saas/cms/m/s/good/delete',
    method: 'post',
    data,
  });
}
/**
 * 更新商品
 */
export function updateGoods(data = {}) {
  return fetch({
    url: '/saas/cms/m/s/good/update',
    method: 'post',
    data,
  });
}

/**
 * 删除拍品
 */
export function deleteAucArtwork(data = {}) {
  return fetch({
    url: '/saas/cms/m/s/auction/artwork/delete',
    method: 'post',
    data,
  });
}

// 删除关联商品
export function goodsRelateDelete(data = {}) {
  return fetch({
    url: `/saas/live/m/s/live/good/cancle/relate`,
    method: 'post',
    data,
  });
}


// 机构信息
export function zaiartOrganizationInfo(data = {}) {
  return fetch({
    url: `api_user/service/w/account/organization/info`,
    method: 'post',
    isZaiartUrl:true,
    data
  })
}

/**
 * 商品列表更新状态
 */
export function updateStatus(data = {}) {
  return fetch({
    url: '/saas/cms/m/s/good/change/status',
    method: 'post',
    data,
  });
}

/**
 * 校验是否绑定收款账户
 */
 export function wxpayHas(data = {}) {
  return fetch({
    url: '/saas/order/w/pay/wxpay/has',
    method: 'post',
    data,
  });
}

/**
 * 作品列表
 */
 export function artWorkList(data = {}) {
  return fetch({
    url: '/saas/cms/m/s/artwork/list',
    method: 'post',
    data,
  });
}